import defineComponent from 'flight';
import Countdown from 'static/script/app/models/countdown';
import _ from 'static/script/libs/underscore';

function CountdownUI() {
    this.defaultAttrs({
        timeLeft: '[data-time-left]',
        auctionEnds: '[data-auction-ends]',
        countdownThreshold: 86399,
        countdownDelay: 500,
        criticalThresholdInMs: 7200000,
        featureSwitches: null
    });

    this._timeoutIds = [];

    this._countDownTick = function(countdownStartTimeInMs) {
        let timeLeft = this.select('timeLeft');
        let timeLeftInMs = countdownStartTimeInMs - this._getTime();
        let timeLeftInSeconds = Math.floor(timeLeftInMs / 1000);

        if (timeLeftInSeconds > 0) {
            timeLeft.text(Countdown.formatRemainingTime(timeLeftInSeconds));
            this._addSetTimeout(this._countDownTick.bind(this, countdownStartTimeInMs));
        } else if (timeLeftInSeconds > -3) {
            timeLeft.text('Avslutad');
            this._addSetTimeout(this._countDownTick.bind(this, countdownStartTimeInMs));
        } else {
            document.location.reload(true);
        }
    };

    this._startCountdown = function(countdownStartTimeInMs) {
        let timeLeftInMs = countdownStartTimeInMs - this._getTime();
        let timeLeftInSeconds = Math.floor(timeLeftInMs / 1000);

        if (timeLeftInSeconds > 0 && timeLeftInSeconds < this.attr.countdownThreshold) {
            this._addSetTimeout(this._countDownTick.bind(this, countdownStartTimeInMs));
        }
    };

    this._addSetTimeout = function(setTimeoutFunc) {
        let timeoutId = setTimeout(setTimeoutFunc, this.attr.countdownDelay);
        this._timeoutIds.push(timeoutId);
    };

    this._removeCountdown = function() {
        if (this._timeoutIds.length > 0) {
            _.each(this._timeoutIds, function(id) {
                window.clearTimeout(id);
            });

            this._timeoutIds = [];
        }
    };

    this._getTime = function() {
        return new Date().getTime();
    };

    this._setupCountDown = function(evt, data) {
        this._removeCountdown();

        let auctionEndTime = this.select('auctionEnds').data('auction-ends');

        let startTime = Countdown.getClientsEndTimeInMsSinceEpoch(auctionEndTime, data.serverTime, data.networkDelay);

        if (startTime < this.criticalThresholdInMs) {
            this.trigger(document, 'ui:countdown:after-critical-threshold');
        }

        this._startCountdown(startTime);
    };

    this.after('initialize', function() {
        if (this.attr.featureSwitches && this.attr.featureSwitches.vipliveupdates) {
            this.on('data:server-time', this._setupCountDown);
            this.on('ui:teardown', this._removeCountdown);
        }
    });

}

module.exports = defineComponent.component(CountdownUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/view-item/countdown-ui.js